import React, { useState, useEffect } from 'react';
import EmailFieldInitialValue from './email-field-initial-value';
import TextAreaInitialValue from './text-area-initial-value';
import TextFieldInitialValue from './text-field-initial-value';

export const InitialValueType = {
  TEXT: 'TEXT',
  JAVASCRIPT: 'JAVASCRIPT',
  SHOPIFY_CUSTOMER_FIRST_NAME: 'SHOPIFY_CUSTOMER_FIRST_NAME',
  SHOPIFY_CUSTOMER_LAST_NAME: 'SHOPIFY_CUSTOMER_LAST_NAME',
  SHOPIFY_CUSTOMER_FULL_NAME: 'SHOPIFY_CUSTOMER_FULL_NAME',
  SHOPIFY_CUSTOMER_EMAIL: 'SHOPIFY_CUSTOMER_EMAIL',
  SHOPIFY_CUSTOMER_PHONE_NUMBER: 'SHOPIFY_CUSTOMER_PHONE_NUMBER'
};

const InitialValue = ({value, onChange, fieldType, radioBoxPrefix}) => {

  const [model, setModel] = useState(value || {});

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  }

  useEffect(() => {
    setModel(value || {});
  }, [ value ]);

  let panelBody = null;
  if (model.enabled) {
    const radioBoxName = radioBoxPrefix + 'initialValueType';
    switch (fieldType) {
      case 'EMAIL':
        panelBody = <EmailFieldInitialValue value={model}
                                            onChange={newValue => setModelAndNotify(newValue)}
                                            radioBoxName={radioBoxName} />;
        break;
      case 'TEXT_AREA':
        panelBody = <TextAreaInitialValue value={model}
                                          onChange={newValue => setModelAndNotify(newValue)}
                                          radioBoxName={radioBoxName} />;
        break;
      default:
        panelBody = <TextFieldInitialValue value={model}
                                           onChange={newValue => setModelAndNotify(newValue)}
                                           radioBoxName={radioBoxName} />;
    }
  }

  return <div className="card my-4">
    <div className="card-header">
      <div className="form-check">
        <input type="checkbox"
               id={radioBoxPrefix + 'initialValueEnabled'}
               className="form-check-input"
               checked={model.enabled == null ? false : model.enabled}
               onChange={e => setModelAndNotify({
                 ...model,
                 enabled: e.target.checked
               })} />
        <label className="form-check-label" htmlFor={radioBoxPrefix + 'initialValueEnabled'}>
          Prepopulate with an initial value
        </label>
      </div>
    </div>
    {panelBody &&
      <div className="card-body">
        {panelBody}
      </div>
    }
  </div>;

}

export default InitialValue;
